<template>
<div id="app">
  <ErrorServer />
  <Loader />
  <!--
  Even when routes use the same component, treat them
  as distinct and create the component again.
  -->
  <RouterView :key="$route.fullPath" />
</div>
</template>

<script>
import appConfig from '@src/app.config.ES6';
import store from '@state/store';
import Loader from 'Loader/Loader';
import ErrorServer from 'Modals/ErrorServer';
import { authComputed, userComputed, mainMethods, errorsComputed } from '@state/helpers';

export default {
  components: {
    ErrorServer,
    Loader,
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  computed: {
    ...authComputed,
    ...errorsComputed,
    ...userComputed,
  },
  mounted() {
    const branchKey = appConfig.BRANCH_KEY ? appConfig.BRANCH_KEY : '';

    branch.init(branchKey, function(err, data) {
      if (err) {
        console.error('Error from Branch: ' + err);
      }
    });

    this.clearErrorCount();

    var cleverTapScript = document.createElement('script');

    cleverTapScript.innerHTML = `
      var clevertap = {event:[], profile:[], account:[], onUserLogin:[], notifications:[], privacy:[]};
      clevertap.account.push({"id": "${appConfig.CLEVERTAP_ACCT_ID}"});
      clevertap.privacy.push({optOut: false});
      clevertap.privacy.push({useIP: true});
      (function () {
        var wzrk = document.createElement('script');
        wzrk.type = 'text/javascript';
        wzrk.async = true;
        wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(wzrk, s);
      })();
      var wrapper = window.parent.document.getElementById('wizParDiv0');
      function closePopUp()
      { wrapper.remove(); }
    `;
    document.head.appendChild(cleverTapScript);
  },
  methods: {
    ...mainMethods,
    clearErrorCount() {
      const errorsShown = JSON.parse(window.localStorage.getItem('errorsShown'));
      const manualRetry = JSON.parse(window.localStorage.getItem('manualRetry'));

      if (errorsShown) {
        window.localStorage.removeItem('errorsShown');
      }

      if (manualRetry) {
        window.localStorage.removeItem('manualRetry');
      }
    },
  },
  watch: {
    serverError() {
      this.$bvModal.show('server-error-modal');
    },
  },
};
</script>

<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';
// Bootstrap Vue
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';

// Design variables and utilities from src/design.
@import 'theme.scss';
@import 'global-app-styles.scss';

*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited,
a:hover {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}
</style>
